var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bank-account-form',{attrs:{"bank-account":_vm.bankAccount},on:{"click:save":_vm.onClickSave,"click:back":_vm.onClickBack}})}
var staticRenderFns = []

export { render, staticRenderFns }